import { trimmedStringFromUnknown } from "../protocol/shared.js";
import { continuitySchema } from "./continuity.js";
import * as z$1 from "zod/v4";
//#region src/schemas/space-mesh/dispatch-brief.ts
const briefLineSchema = z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1));
const dispatchBriefSchema = z$1.strictObject({
	activatedBy: briefLineSchema,
	sourceMessage: briefLineSchema,
	replyTarget: briefLineSchema,
	continuity: continuitySchema,
	whatYouCanDoNow: briefLineSchema
});
//#endregion
export { dispatchBriefSchema };

//# sourceMappingURL=dispatch-brief.js.map